import CustomInput from "@/components/ui/form/CustomInput";
import CustomTextarea from "@/components/ui/form/CustomTextarea";
import RenderFieldError from "@/components/ui/form/RenderFieldError";
import { TContactFormData } from "@/schema/contactSchema";
import React from "react";
import { FieldErrors, UseFormRegister } from "react-hook-form";

type TContactFormFields = {
  register: UseFormRegister<TContactFormData>;
  errors: FieldErrors<TContactFormData>;
};

const ContactFormFields = ({ register, errors }: TContactFormFields) => {
  return (
    <div className="flex flex-col gap-4">
      <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-4">
        <div>
          <CustomInput
            type="text"
            placeholder="Name"
            className=""
            {...register("name")}
          />
          <RenderFieldError errors={errors} fieldName="name" />
        </div>
        <div>
          <CustomInput
            type="email"
            placeholder="Enter your email"
            className=""
            {...register("email")}
          />
          <RenderFieldError errors={errors} fieldName="email" />
        </div>
      </div>

      <div>
        <CustomInput
          type="text"
          placeholder="Subject"
          className=""
          {...register("subject")}
        />
        <RenderFieldError errors={errors} fieldName="subject" />
      </div>

      <div>
        <CustomTextarea
          maxLength={400}
          placeholder="Message"
          rows={8}
          {...register("message")}
          className="resize-none"
        />
        <RenderFieldError errors={errors} fieldName="message" />
      </div>
    </div>
  );
};

export default ContactFormFields;
